'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * numberWithCommas [ref: http://goo.gl/03WHAI]
 */

var numberWithCommas = function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

exports.default = numberWithCommas;
module.exports = exports['default'];